import { IntlShape } from "react-intl";
import { getLocale } from "../parameters";
import { IPlan } from "../types";

export default (name: IPlan["name"], intl: Partial<IntlShape>) => {
    const locale = getLocale(intl.locale!);
    if (!name) return "";
    if (name[locale]) return name[locale];
    if (name.en) return name.en;
    return name[Object.keys(name)[0]];
};

export const getNameLang = (names: IPlan["name"], name: string) => {
    for (let [lang, text] of Object.entries(names)) {
        if (text === name) {
            return lang;
        }
    }
}